module.exports = __webpack_public_path__ + "geoCompassMinus_dark.fa5500be3018476e443e313b8a2018ea.png";